<template>
  <div class="public-layout">
    <router-view />
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="green lighten-2"
      @click="toTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data: () => ({
    fab: false
  }),
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>

<style>
.public-layout .v-footer a {
  color: white !important;
}

.public-layout .v-parallax__content {
  background-image: linear-gradient(
    to bottom,
    rgb(0, 43, 53),
    rgba(0, 113, 141, 0.486),
    rgb(0, 43, 53)
  );
}

.public-layout .v-toolbar__title a {
  color: inherit;
  text-decoration: none;
}
</style>